import * as bootstrap from 'bootstrap'
import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { convertRemToPixels } from "../utils/WWWFunctions";

export default class SingleProgramme {
  constructor(dom) {
    this.dom = dom;


    window.addEventListener("resize", () => this.resize());
  }

  async init() {
    this.initResponsiveHelper();

    let _this = this

    ScrollTrigger.matchMedia({
      "(min-width: 769px)": function () {
        // console.log('d');
        ScrollTrigger.create({
          trigger: _this.dom.querySelector('.programme-details'),
          start: `top ${document.querySelector('header').offsetHeight + convertRemToPixels(2)}px`,
          end: () => {
            let h = _this.dom.querySelector('.content_modules').offsetHeight - _this.dom.querySelector('.programme-details').offsetHeight
            console.log(h);
            return `+=${h}`
          },
          pin: true,
          // markers: true,
        });
      },
      "(max-width: 768px)": function () {

      },
    })

    this.handleLb()
  }

  handleLb() {
    const ex_acts = this.dom.querySelectorAll('.content-part[data-type="_extension_activities"] div.card a[href="#"]')
    const lb = document.querySelector('#programmeLbModal')
    if (lb) {
      const programmeLbModal = new bootstrap.Modal(lb, {
        keyboard: false
      })
      let lb_content = lb.querySelector('.modal-body')
      lb.addEventListener('hidden.bs.modal', event => {
        lb_content.innerHTML = ''
      })
      ex_acts.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()
          let details = item.parentNode.parentNode.parentNode.querySelector("[js-lb-content]");
          if (!details.innerHTML) {
            return
          }
          lb_content.innerHTML = details.innerHTML;
          let btn = lb_content.querySelector('._btn')
          lb_content.querySelector('article').innerHTML = lb_content.querySelector('article').dataset.content
          lb_content.querySelector('article').removeAttribute('data-content')
          if (lb_content.querySelector('._btn')) {
            const btn_wrap = document.createElement('a');
            btn_wrap.setAttribute("class", `btn _pale-yellow`);
            btn_wrap.setAttribute("href", btn.dataset.href);
            btn_wrap.setAttribute("target", '_blank');
            btn_wrap.innerHTML = btn.dataset.lbl
            btn.removeAttribute('data-href')
            btn.removeAttribute('data-lbl')
            btn.append(btn_wrap);
          }
          programmeLbModal.show()
        })
      });
    }


  }

  initResponsiveHelper() {

  }

  resize() {
  }

  destory() {

  }
}
